<template>
  <div class="first-section">
    <div class="content">
      <h1>LOADING...</h1>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.first-section {
  width: 100vw;
  height: 100vh;
  display: flex;

  align-items: center;
  justify-content: center;

  .content {
    flex-wrap: wrap;
    text-align: center;

    img {
      width: 30px;
    }
  }
}
</style>
